import axios from "axios";
import { CONST } from "../config/const";

// リストID一覧
export async function getProductListIDs(
  product_id: string,
  customer_list_group_id: string
) {
  try {
    const path = "productListIDs";
    const params = { product_id, customer_list_group_id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// リストID登録
export async function postProductListID(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "productListID";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
